import React, { ReactNode, useEffect } from 'react';

import * as amplitude from '@amplitude/analytics-browser';

export const AmplitudeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const amplitudeKey =
    process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
      ? process.env.NEXT_PUBLIC_AMPLITUDE_PROD_KEY!
      : process.env.NEXT_PUBLIC_AMPLITUDE_DEV_KEY!;

  useEffect(() => {
    amplitude.init(amplitudeKey, undefined, {
      defaultTracking: {
        sessions: true,
        pageViews: {
          trackHistoryChanges: 'all',
        },
        formInteractions: true,
        fileDownloads: true,
      },
    });
  }, []);

  return <>{children}</>;
};
